/**
 * SGKC037A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Sgkc037aReqFixempCspManagenoTableInfoDto {

    /**
     * 確定使用量再取込管理通番号
     */
    fixempCspManageno?: string;
    /**
     * 再取込処理ステータスコード
     */
    reimportTrnStatuscode?: string;
}

